import React from 'react';
import isFunction from 'lodash/isFunction';
import useFormField from '../hooks/useFormField';
import Adapter from './Adapter';

export default function FormField({ children, ...props }) {
  const {
    defaultHandler,
    formFieldApi,
    formFieldContext,
    formFieldProps,
    formFieldState,
    formFieldRef,
    render,
    userProps,
  } = useFormField(props);

  if (isFunction(children)) {
    return render(children({ ...formFieldContext, formFieldApi, formFieldState }));
  }

  return render(
    <Adapter
      component="FormField"
      {...formFieldProps}
      context={formFieldContext}
      defaultHandler={defaultHandler}
      formFieldApi={formFieldApi}
      formFieldState={formFieldState}
      ref={formFieldRef}
      userProps={userProps}
    >
      {children}
    </Adapter>
  );
}
